import component from './LayoutHeader.vue'
export default component
